import { FailedChecks, UserPreEvent } from '@goldcast/api/backend';

import { FormattedAlertForStaff, StaffColumnKey } from './types';

import { FormattedAlert } from '@/studio/alerts/types';
import { EmailTypes } from '@/studio/emailSchedule/store/types';

export const getRoleMessage = (role: string) => {
  switch (role) {
    case 'Producer':
      return 'Producers have backstage access can use all features to run an event.';
    case 'Coordinator':
      return 'Coordinators have backstage access but cannot go on stage. They can only share content to the stage and engage with the audience via chat, Q&A, polls, and surveys.';
    default:
      return '';
  }
};

const failedCheckKeyToAlertMessageMap = {
  staffs_not_added_to_any_broadcasts: 'Staff is not added to any broadcasts.',
  staff_not_completed_tech_check: 'Staff has not completed the tech check.'
};

export function formatFailedChecksForStaff(failedChecks: FailedChecks | {} = {}): FormattedAlertForStaff {
  const formattedAlertsForStaff: FormattedAlertForStaff = {};

  Object.keys(failedChecks).forEach(key => {
    const failedCheck = failedChecks[key];
    const failedCheckKey = key as keyof FailedChecks;

    switch (failedCheckKey) {
      case 'staff_not_completed_tech_check':
      case 'staffs_not_added_to_any_broadcasts':
        (failedCheck as UserPreEvent[]).forEach((c, i) => {
          const key = `${failedCheckKey}_${c.user_id}${i}`;
          const formattedAlert: FormattedAlert = {
            key: key,
            message: failedCheckKeyToAlertMessageMap[failedCheckKey],
            actionRequired: !!c.action_required
          };
          addFormattedAlertToStaffId(formattedAlertsForStaff, c.user_id, formattedAlert);
        });
        break;
      default:
    }
  });

  return formattedAlertsForStaff;
}

export function addFormattedAlertToStaffId(
  formattedAlertsForStaff: FormattedAlertForStaff,
  userId: string,
  formattedAlert: FormattedAlert
) {
  if (formattedAlertsForStaff[userId]) {
    formattedAlertsForStaff[userId].push(formattedAlert);
  } else {
    formattedAlertsForStaff[userId] = [formattedAlert];
  }
}

export const STAFF_COLUMNS: {
  name: string;
  key: StaffColumnKey;
  allowFiltering?: boolean;
}[] = [
  {
    name: 'Full Name',
    key: 'full_name'
  },
  {
    name: 'Title',
    key: 'title'
  },
  {
    name: 'Company',
    allowFiltering: true,
    key: 'company'
  },
  {
    name: 'Role',
    key: 'role'
  },
  {
    name: 'Magic Link',
    key: 'magic_link'
  }
];

export const StaffEmailTypes: EmailTypes[] = ['StaffInvite', 'Staff-Reminder-1h', 'Staff-Reminder-1d'];
